import React from 'react';
import HousingSavedScenarios from './HousingSavedScenarios';
import CarSavedScenarios from './CarSavedScenarios';
import CareerSavedScenarios from './CareerSavedScenarios';
import RetirementSavedScenarios from './RetirementSavedScenarios';
import { ComparisonScenariosProps } from '../types/shared';
import { HousingComparisonData } from '../types/housingComparison';
import { CarComparisonData } from '../types/carComparison';
import { CareerComparisonData } from '../types/careerComparison';
import { UserProfile } from '../types/advanced-retirement';

export type CalculatorType = 'housing' | 'car' | 'career' | 'retirement';

interface ScenariosTabProps extends ComparisonScenariosProps {
  calculatorType: CalculatorType;
  currentData?: HousingComparisonData | CarComparisonData | CareerComparisonData | UserProfile;
}

const ScenariosTab: React.FC<ScenariosTabProps> = ({
  calculatorType,
  comparisonMode = false,
  user,
  guestScenario,
  currentData,
  onLoadScenarioToA,
  onLoadScenarioToB,
  onSaveScenario
}) => {
  const commonProps = {
    comparisonMode,
    user,
    guestScenario,
    onLoadScenarioToA,
    onLoadScenarioToB,
    onSaveScenario
  };

  switch (calculatorType) {
    case 'housing':
      return (
        <HousingSavedScenarios
          {...commonProps}
          currentData={currentData as HousingComparisonData}
        />
      );
    
    case 'car':
      return (
        <CarSavedScenarios
          {...commonProps}
          currentData={currentData as CarComparisonData}
        />
      );
    
    case 'career':
      return (
        <CareerSavedScenarios
          {...commonProps}
          currentData={currentData as CareerComparisonData}
        />
      );
    
    case 'retirement':
      return (
        <RetirementSavedScenarios
          {...commonProps}
          currentData={currentData as UserProfile}
        />
      );
    
    default:
      return (
        <div style={{ 
          textAlign: 'center', 
          color: '#6b7280', 
          fontSize: '0.9rem',
          padding: '20px',
          background: 'white',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}>
          Unsupported calculator type: {calculatorType}
        </div>
      );
  }
};

export default ScenariosTab;